var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.total),function(i){return _c('pdf',{key:'pdfPreview' + i,attrs:{"src":_vm.stream,"page":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }